var _radialGradient, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTubeSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a10",
    cx: 0.66,
    fx: 0.66,
    cy: 0.3125,
    fy: 0.3125,
    gradientTransform: "scale(1.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFFFFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFFFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "transform-origin": "center",
    fill: "none",
    stroke: "url(#a10)",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeDasharray: "200 1000",
    strokeDashoffset: 0,
    cx: 100,
    cy: 100,
    r: 70
  }, /*#__PURE__*/React.createElement("animateTransform", {
    type: "rotate",
    attributeName: "transform",
    calcMode: "spline",
    dur: 2,
    values: "360;0",
    keyTimes: "0;1",
    keySplines: "0 0 1 1",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "transform-origin": "center",
    fill: "none",
    opacity: 0.2,
    stroke: "#FFFFFF",
    strokeWidth: 15,
    strokeLinecap: "round",
    cx: 100,
    cy: 100,
    r: 70
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeSpinner);
export default __webpack_public_path__ + "static/media/tube-spinner.d7626f3a9e2fcef42c1cff4f5458e208.svg";
export { ForwardRef as ReactComponent };